// extracted by mini-css-extract-plugin
export var active = "side-nav-module--active--86a96";
export var backIcon = "side-nav-module--backIcon--ee50a";
export var backIconDesktop = "side-nav-module--backIconDesktop--63414";
export var backIconMobile = "side-nav-module--backIconMobile--d5f45";
export var btnAllTopics = "side-nav-module--btnAllTopics--034ff";
export var btnAllTopicsText = "side-nav-module--btnAllTopicsText--e1399";
export var btnSectionTitle = "side-nav-module--btnSectionTitle--c0ddd";
export var childContainer = "side-nav-module--childContainer--1fd14";
export var container = "side-nav-module--container--f4adf";
export var expander = "side-nav-module--expander--8f523";
export var expanderIcon = "side-nav-module--expanderIcon--7df5d";
export var navLink = "side-nav-module--navLink--93ede";
export var navNode = "side-nav-module--navNode--4c806";
export var navSection = "side-nav-module--navSection--ac696";
export var navTopic = "side-nav-module--navTopic--f562e";
export var sectionsWrap = "side-nav-module--sectionsWrap--50e7f";
export var subrootContainer = "side-nav-module--subrootContainer--f9fa1";
export var title = "side-nav-module--title--ff4cf";
export var topicIcon = "side-nav-module--topicIcon--de12b";